import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCreditCard2"><Path d="M4.5 4C3.11929 4 2 5.11929 2 6.5V9.5H22V6.5C22 5.11929 20.8807 4 19.5 4H4.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M22 10.5H2V17.5C2 18.8807 3.11929 20 4.5 20H19.5C20.8807 20 22 18.8807 22 17.5V10.5ZM6 13.5C6 13.2239 6.22386 13 6.5 13H9.5C9.77614 13 10 13.2239 10 13.5C10 13.7761 9.77614 14 9.5 14H6.5C6.22386 14 6 13.7761 6 13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCard2;
